import {ApplicationConfig, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {provideRouter, withInMemoryScrolling} from '@angular/router';

import {routes} from './app.routes';
import {provideClientHydration} from '@angular/platform-browser';
import {MetrikaModule} from "ng-yandex-metrika";
import {env} from "../environments/environment";
import {provideHttpClient} from "@angular/common/http";
import {provideLucideIcons} from "@lucide/angular";
import {APP_LUCIDE_ICON_COMPONENTS} from "./icons/lucide-icons";

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({eventCoalescing: true}),
        provideRouter(
            routes,
            withInMemoryScrolling({
                scrollPositionRestoration: 'top',
                anchorScrolling: 'enabled',
            })
        ),
        provideHttpClient(),
        provideClientHydration(),
        provideLucideIcons(...APP_LUCIDE_ICON_COMPONENTS),
        env.METRIKA_ENABLED ? importProvidersFrom(
            MetrikaModule.forRoot([
                {
                    id: env.METRIKA_COUNTER_ID,
                    clickmap: true,
                    trackLinks: true,
                    accurateTrackBounce: true,
                    webvisor: true
                },
            ])
        ) : importProvidersFrom(),
    ],
};
